var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.586 4.215a.562.562 0 0 0-.794-.795l-2.79 2.79-2.791-2.792a.562.562 0 0 0-.795.795l2.79 2.789-2.792 2.79a.562.562 0 0 0 .795.794L6.998 7.8l2.791 2.792a.562.562 0 0 0 .795-.795l-2.79-2.789z"
  })));
};
export default SvgX;